(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8171],{

/***/ 3187:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/cloud",
      function () {
        return __webpack_require__(2181);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MethodologyAnchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var steps = [
    {
        step: "01",
        title: "Discovery sprint",
        desc: "2 weeks, fixed price. We scope the problem, audit your data, and produce a written roadmap, cost estimate, and risk register. You decide whether to proceed — no commitment beyond the sprint."
    },
    {
        step: "02",
        title: "Build",
        desc: "Fixed-scope first phase or time-and-materials with a cap. Production-grade code, not a prototype. Delivered into your cloud environment with tests, monitoring, and handoff documentation."
    },
    {
        step: "03",
        title: "Operate",
        desc: "4–8 week warranty period post-handoff. Bugs and regressions fixed at zero cost. Ongoing ops available — we don't disappear after delivery."
    }, 
];
function MethodologyAnchor() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-14 bg-gray-50 border-t border-gray-100",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-5xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-2",
                    children: "How an engagement works"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-gray-500 mb-10 text-base",
                    children: "No open-ended retainers. Every engagement starts with a bounded, fixed-price discovery."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-8",
                    children: steps.map(function(s) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-3xl font-bold text-[#f1aa4e]",
                                    children: s.step
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-lg font-semibold text-gray-900",
                                    children: s.title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-gray-600 text-sm leading-relaxed",
                                    children: s.desc
                                })
                            ]
                        }, s.step);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mt-10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/itmtb-how-we-work",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "text-blue-600 font-semibold text-sm hover:underline",
                            children: "Full methodology and engagement shapes →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SuccessStoryEmbed; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2684);





var allCaseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_3__.filter(function(item) {
    var ref;
    return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
}).map(function(item) {
    return {
        title: item.meta.title || "",
        slug: item.meta.slug || "",
        img: item.meta.img || null,
        industry_descriptor: item.meta.industry_descriptor || null,
        outcome_metric: item.meta.outcome_metric || null,
        refer: Array.isArray(item.meta.refer) ? item.meta.refer : [],
        date: item.meta.date || ""
    };
});
function SuccessStoryEmbed(param) {
    var referTag = param.referTag, _maxItems = param.maxItems, maxItems = _maxItems === void 0 ? 3 : _maxItems, _heading = param.heading, heading = _heading === void 0 ? "Work we've shipped for clients like you" : _heading;
    var stories = referTag ? allCaseStudies.filter(function(s) {
        return s.refer.includes(referTag);
    }) : [];
    if (stories.length === 0) {
        stories = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(allCaseStudies).sort(function(a, b) {
            return b.date > a.date ? 1 : -1;
        });
    }
    var visible = stories.slice(0, maxItems);
    if (!visible.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "py-12 px-6 md:px-[60px] bg-gray-50 text-left",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-6xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-left",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-1 md:grid-cols-3 gap-6 mb-8",
                    children: visible.map(function(story) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/".concat(story.slug),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "group bg-white border border-gray-200 rounded-xl overflow-hidden hover:border-blue-400 hover:shadow-md transition-all flex flex-col",
                                children: [
                                    story.img && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative w-full h-44 bg-gray-100",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            src: story.img,
                                            alt: story.title,
                                            fill: true,
                                            className: "object-cover",
                                            sizes: "(max-width: 768px) 100vw, 400px",
                                            placeholder: "blur",
                                            blurDataURL: "/blogImages/hero/placeholder.webp"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-5 flex flex-col flex-1",
                                        children: [
                                            story.industry_descriptor && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-blue-500 text-xs uppercase tracking-wide font-medium mb-2",
                                                children: story.industry_descriptor
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "text-base font-semibold text-gray-900 group-hover:text-blue-600 transition-colors leading-snug mb-3 flex-1",
                                                children: story.title
                                            }),
                                            story.outcome_metric && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-sm text-gray-500 mt-auto pt-3 border-t border-gray-100",
                                                children: story.outcome_metric
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, story.slug);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/success-stories",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "inline-block border border-gray-300 hover:border-blue-500 text-gray-700 hover:text-blue-600 font-semibold px-7 py-3 rounded-lg transition-colors text-sm",
                            children: "See all success stories →"
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 2181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ cloud; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1180);
/* harmony import */ var _blogs_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2684);
/* harmony import */ var _components_services_Service2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3230);
/* harmony import */ var _components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2100);
/* harmony import */ var _components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(710);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2616);
/* harmony import */ var _components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5733);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4837);






var Capabilities2 = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5791), __webpack_require__.e(8388), __webpack_require__.e(5290), __webpack_require__.e(7517), __webpack_require__.e(7113)]).then(__webpack_require__.bind(__webpack_require__, 7517));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7517)
            ];
        }
    },
    ssr: false
});







var ContactUsHome = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 6245).then(__webpack_require__.bind(__webpack_require__, 6245));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6245)
            ];
        }
    },
    ssr: false
});
var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2941).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    },
    ssr: false
});
cloud.title = "Cloud Consulting Services — AWS, Azure, GCP for Enterprise India | ITMTB";
cloud.desc = "ITMTB architects and manages production cloud on AWS, Azure, and GCP — specialising in infrastructure for AI agent deployments, cloud migrations, and data platform engineering for Indian enterprises.";
cloud.header_img = "https://www.itmtb.com/services/capability/cloud.webp";
cloud.keywords = "cloud infrastructure for AI workloads India, AWS Azure GCP consulting India, cloud migration consulting India enterprise, production cloud AI deployment India, cloud cost optimisation India";
var faqItems = [
    {
        q: "Which cloud provider is best for AI workloads in India — AWS, Azure, or GCP?",
        a: "The right answer depends on your existing stack, AI use case, and compliance requirements. AWS has the broadest service coverage and competitive compute costs in the ap-south-1 (Mumbai) region — the default starting point for most new deployments. Azure is the right call if your organisation already uses Microsoft Dynamics 365, Office 365, or Azure AD: managed identity integration across services significantly reduces credential management complexity. GCP's Vertex AI and BigQuery are the strongest managed offerings for teams building heavily on Google's AI infrastructure. For data residency: all three providers have India regions (AWS ap-south-1, Azure Central India, GCP asia-south1). For DPDP compliance, the provider is less important than configuration — we've delivered compliant deployments on all three. We help you evaluate during the discovery sprint rather than picking based on vendor marketing."
    },
    {
        q: "What does a cloud migration actually involve — how long does it take?",
        a: "A cloud migration has four phases. Assessment (2 weeks, fixed price): we inventory your current infrastructure, map dependencies, identify migration risks, and produce a migration runbook with a timeline and cost estimate. Pilot migration (4–6 weeks): we migrate one non-critical workload to validate the runbook, test backup and rollback procedures, and find infrastructure gaps before the bulk migration. Bulk migration (8–20 weeks depending on number of services and whether re-architecture is needed alongside migration). Post-migration stabilisation (4 weeks): monitoring, cost right-sizing, and performance tuning. Total calendar time typically runs 16–28 weeks for a mid-size enterprise migrating 20–50 services. The biggest variable is organisational: how quickly your application teams can validate migrated workloads."
    },
    {
        q: "What does production cloud infrastructure for AI agents actually require?",
        a: "AI agents and ML pipelines have different infrastructure requirements than web applications. Key components: inference compute — GPU instances or managed inference endpoints (AWS SageMaker, Azure AI Foundry, Vertex AI) sized for your model and latency requirements; vector database — for RAG retrieval, options include Pinecone, Weaviate, pgvector on RDS, or managed equivalents on each cloud; high-throughput message queues — for agent event loops and async tool call processing (SQS, Azure Service Bus, Pub/Sub); cost guardrails — inference spend can spike unpredictably at scale, requiring budget alerts and automatic endpoint scaling-to-zero when idle; and networking — agents calling internal systems need private connectivity (VPC endpoints, private link) rather than public internet routes. We architect these components during the discovery sprint, selecting managed services where they reduce operational burden."
    },
    {
        q: "How do you handle data residency requirements in Indian cloud deployments?",
        a: "Data residency — keeping specific data categories within Indian borders — is required by several regulations: RBI mandates that payment system data be stored in India; SEBI has data localisation requirements for market intermediaries; IRDAI requires insurance data in India. On AWS, Azure, and GCP, data residency is achieved through region selection and service configuration. Cloud services are global by default — some services (CDN, DNS, global load balancers) pass data through international infrastructure even when primary compute is in India. We audit your data flows, identify which services require region-pinning and which cross-region services need alternatives, and implement the controls required for your specific regulatory obligations."
    },
    {
        q: "What is cloud cost optimisation and how much can I expect to save?",
        a: "Cloud cost optimisation is the process of identifying and eliminating unnecessary spend without reducing capability. Common sources of overspend: compute instances sized for peak load that run continuously at 15–20% utilisation (typical savings from right-sizing: 25–40%); storage accumulating without lifecycle policies moving aged data to lower-cost tiers; staging and development environments running 24\xd77 at production scale; AI inference endpoints staying warm when idle; and reserved instances purchased for workloads that have since changed. Organisations that haven't conducted a cost review in the past 12 months typically see 20–35% savings. The review takes 2–3 weeks and produces a prioritised list of changes with projected savings per item — you can implement selectively based on engineering capacity."
    },
    {
        q: "How does ITMTB price an engagement?",
        a: "Pricing follows the engagement model. Discovery sprints are fixed-price for a fixed timebox. Build engagements are scoped after discovery — fixed-scope, time-and-materials, or outcome-linked. Managed services are billed monthly with defined SLAs. Total cost depends on scope, integration complexity, QA depth, and post-launch support — we publish a transparent breakdown for buyers evaluating their options.",
        link: "/blog/custom-software-development-cost-india",
        linkLabel: "Read the cost guide"
    },
    {
        q: "What does an engagement with ITMTB look like?",
        a: "Every engagement starts with a fixed-scope, fixed-price discovery sprint — typically 2 weeks. You leave with a written roadmap, risk register, cost estimate, and timeline before committing to a build. We then offer four engagement models: fixed-scope builds, time-and-materials, outcome-linked retainers, and managed services post-launch. If discovery doesn't justify proceeding, you can stop there — no obligation.",
        link: "/itmtb-how-we-work",
        linkLabel: "See how we work"
    }, 
];
cloud.faq = faqItems;
function cloud() {
    var insights = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return ![
            "case-study",
            "tech"
        ].includes(item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category);
    });
    var caseStudies = _blogs_json__WEBPACK_IMPORTED_MODULE_2__.filter(function(item) {
        var ref;
        return (item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : ref.category) === "case-study";
    });
    var cloudInsights = insights.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Cloud");
    });
    var cloudCaseStudies = caseStudies.filter(function(item) {
        var ref, ref1;
        return item === null || item === void 0 ? void 0 : (ref = item.meta) === null || ref === void 0 ? void 0 : (ref1 = ref.refer) === null || ref1 === void 0 ? void 0 : ref1.includes("Cloud");
    });
    if (cloudInsights.length === 1) {
        insights = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(cloudInsights).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights.filter(function(item) {
            return !cloudInsights.includes(item);
        }), 1)));
    } else if (cloudInsights.length >= 2) {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(cloudInsights, 2);
    } else {
        insights = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(insights, 2);
    }
    if (cloudCaseStudies.length === 1) {
        caseStudies = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(cloudCaseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies.filter(function(item) {
            return !cloudCaseStudies.includes(item);
        }), 1)));
    } else if (cloudCaseStudies.length >= 2) {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(cloudCaseStudies, 2);
    } else {
        caseStudies = (0,_utils_blogUtils__WEBPACK_IMPORTED_MODULE_12__/* .getRandom */ .s)(caseStudies, 2);
    }
    var subServices = [
        {
            img: null,
            key: "Production Cloud for AI Workloads",
            title: "AI agents run on cloud. We architect and manage the layer they depend on.",
            text: "AI agents and ML pipelines need cloud infrastructure designed for them: GPU inference compute, vector databases for RAG retrieval, high-throughput message queues for agent event loops, and cost guardrails on inference spend that can spike unpredictably at scale.\n\nWe architect these components from first principles — selecting the right instance types on AWS, Azure, or GCP, configuring managed inference endpoints, setting up auto-scaling and cost alerts, and designing private networking so your agents can reach internal systems without public internet exposure."
        },
        {
            img: null,
            key: "Cloud Architecture and Infrastructure Design",
            title: "Getting your cloud architecture right from the start avoids the two most expensive outcomes: over-provisioned and under-provisioned.",
            text: "We design cloud architectures on AWS, Azure, and GCP tailored to your workload profile — multi-region resilience where required, auto-scaling for variable traffic, and cost optimisation built into the design rather than retrofitted after the bill arrives.\n\nFor enterprises with existing infrastructure: we audit the current state and produce a roadmap to the target architecture. For greenfield deployments: we select services, size infrastructure, and document the architecture decisions so your team can operate and extend it."
        },
        {
            img: null,
            key: "Cloud Migration",
            title: "We migrate on-premises systems and between cloud providers — with a runbook your team can follow and roll back from.",
            text: "We start with a migration assessment: inventory of what's running where, dependencies, and migration risk per service. Then we design the migration path — lift-and-shift where cost or time dictates, re-architecture where the current design wouldn't scale in cloud.\n\nWe've executed migrations from on-premises Windows Server to Azure, from AWS to GCP for cost reasons, and from legacy hosting to AWS for Indian e-commerce platforms scaling to meet demand. Migration execution follows a defined runbook so your team is never surprised."
        },
        {
            img: null,
            key: "Data Platform and Pipeline Engineering",
            title: "Your AI agents are only as good as the data they can reach — we build the data layer.",
            text: "We build data platforms that connect your operational systems — ERPs, CRMs, transaction databases, file stores — into a clean, structured layer that AI agents and analytics tools can query reliably.\n\nThis includes ingestion pipelines (real-time and batch), transformation layers that normalise data from disparate sources, data quality monitoring, and cost-efficient storage tiering on AWS S3, Azure Data Lake, or GCP Cloud Storage. For enterprises with existing data warehouses (Snowflake, Redshift, BigQuery), we extend rather than replace."
        },
        {
            img: null,
            key: "Cloud Cost Optimisation",
            title: "Cloud bills grow faster than usage when architecture decisions made under deadline pressure aren't revisited.",
            text: "Common leaks we find: oversized compute reserved instances that no longer match actual workload; S3/GCS storage accumulating without lifecycle policies; staging environments running 24\xd77; AI inference endpoints staying warm when idle. We conduct a cloud cost review, produce a prioritised list of savings opportunities with projected impact per item, and implement the changes. Typical outcome: 20–35% cost reduction without any reduction in capability."
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify({
                            "@context": "https://schema.org",
                            "@type": "ProfessionalService",
                            name: "Cloud Consulting Services — AWS, Azure, GCP for Enterprise India",
                            url: "https://www.itmtb.com/services/cloud",
                            image: "https://www.itmtb.com/services/capability/cloud.webp",
                            description: "ITMTB architects and manages production cloud on AWS, Azure, and GCP — specialising in infrastructure for AI agent deployments, cloud migrations, and data platform engineering for Indian enterprises.",
                            provider: {
                                "@type": "Organization",
                                name: "ITMTB Technologies",
                                url: "https://www.itmtb.com",
                                logo: "https://www.itmtb.com/logo.webp"
                            },
                            areaServed: [
                                {
                                    "@type": "Place",
                                    name: "India"
                                }
                            ],
                            serviceType: [
                                "Cloud Infrastructure for AI Workloads",
                                "AWS Consulting India",
                                "Azure Consulting India",
                                "GCP Consulting India",
                                "Cloud Migration Consulting",
                                "Production Cloud AI Deployment",
                                "Cloud Cost Optimisation",
                                "Data Platform Engineering", 
                            ],
                            sameAs: [
                                "https://www.linkedin.com/company/itmtb-technologies/",
                                "https://x.com/ITMTBTech",
                                "https://www.instagram.com/itmtbtech/", 
                            ]
                        })
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_Service2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                heading: "Production Cloud for Enterprise AI",
                paragraph: "Production AI systems don't run on laptops. They need cloud infrastructure designed for the job: GPU inference compute, vector databases for retrieval, high-throughput queues for agent event loops, and data residency controls for Indian regulatory compliance.\n\nITMTB architects, migrates, and manages cloud infrastructure on AWS, Azure, and GCP — with a specialist focus on the infrastructure that production AI systems require. We rebuilt a cloud stack that handled 3\xd7 peak traffic without degradation, delivering for a D2C brand scaling its digital operations in 4 months.\n\nThe cloud layer is where AI projects fail silently — cost overruns from idle inference endpoints, cold-start latency, misconfigured IAM, broken observability. We make sure yours doesn't.",
                bgPath: "/services/capability/cloud.webp",
                primaryCta: {
                    label: "Talk to us →",
                    href: "/contact-us"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_trust_SuccessStoryEmbed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                referTag: "Cloud",
                maxItems: 3,
                heading: "Selected work in cloud"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_10__/* .CustomerSection */ .a, {
                title: "Trusted by"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_MethodologyAnchor__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Capabilities2, {
                dataList: subServices,
                bg: "bg-[#402A6A]",
                insights: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(caseStudies).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(insights)),
                hideFooter: true,
                hideCardSubtitle: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "px-8 md:px-[60px] py-8 bg-white border-t border-gray-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "max-w-4xl text-sm text-gray-500 leading-relaxed",
                    children: [
                        "Cloud is the layer our software runs on — it sits within our broader",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/services/custom-software-development",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "custom software development"
                            })
                        }),
                        " ",
                        "practice, alongside platform engineering, application development, and AI-enabled systems. For buyers comparing providers or estimating spend, our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/blog/cloud-price-comparison",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "cloud cost comparison guide"
                            })
                        }),
                        " ",
                        "explains how to model public cloud cost by workload, usage, and cost allocation, and our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/blog/aws-cost-optimization-unused-resources",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "AWS cost optimisation guide"
                            })
                        }),
                        " ",
                        "covers how to identify idle and oversized AWS resources and validate them before anything is removed. When the decision involves a captive or hybrid facility rather than public cloud, our",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                            href: "/services/data-center-project-readiness-governance",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "text-indigo-600 font-medium hover:text-indigo-800 transition-colors",
                                children: "data centre project readiness and delivery governance"
                            })
                        }),
                        " ",
                        "service helps test assumptions and govern the setup before major commitments."
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceFAQ__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                items: faqItems
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_services_ServiceEngagementLinks__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContactUsHome, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {})
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,2684,1831,9774,2888,179], function() { return __webpack_exec__(3187); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);